import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SnackBarComponent } from '@core/snackbar/snackbar/snackbar.component';
import { ControlPageFacade } from '@ra-state';
import { CommonService } from '@rockwell-automation-inc/service';
import { AppInsightsMonitoringService } from '@servicesV2/app-insights-monitoring.service';
import { LoggerService } from '@servicesV2/logger.service';
import { filter, skipWhile, switchMap, take, tap } from 'rxjs';
import { UiStateFacade } from './+state/ui-state/store';
import { AuthenticationService } from './v2/auth/auth.service';
import { SpinnerComponent } from './v2/core/spinner/spinner.component';

@Component({
  selector: 'app-root',
  standalone: true,
  styleUrls: ['./app.component.scss'],
  templateUrl: './app.component.html',
  imports: [RouterOutlet, SpinnerComponent, AsyncPipe, SnackBarComponent],
})
export class AppComponent {
  private readonly authService = inject(AuthenticationService);
  private readonly controlPageFacade = inject(ControlPageFacade);
  private readonly uiStateFacade = inject(UiStateFacade);
  private readonly logger = inject(LoggerService).withContext('AppComponent');
  private readonly appInsightsMonitoringService = inject(AppInsightsMonitoringService);
  private readonly commonService = inject(CommonService);

  isLoading$ = this.uiStateFacade.isLoading$;

  extendSession$ = this.controlPageFacade.extendSession$.pipe(
    filter((value) => value),
    tap(() => {
      this.authService.checkAuth0Session();
      this.controlPageFacade.setExtendSession(false);
    }),
  );
  logoutSession$ = this.controlPageFacade.logoutSession$.pipe(
    filter((value) => value),
    tap(() => {
      this.authService.logout();
      this.controlPageFacade.setLogoutSession(false);
    }),
  );

  constructor() {}

  initApp$ = this.authService.isAuthenticated$.pipe(
    skipWhile((it) => it.valueOf() === false),
    // finish after the first true
    take(1),
    // this.authService.user$ is triggred multiple times for each /authorize call
    // take(1) is to stop the subscription after emitting once
    switchMap(() => this.authService.user$.pipe(take(1))),
    tap((userProfile) => {
      this.controlPageFacade.setUserLoggedIn(userProfile);
      this.commonService.setUserId(userProfile?.userId);
      this.appInsightsMonitoringService.startAppInsightMonitoring().catch((err) => {
        this.logger.warn('Failed to start AppInsights monitoring', err);
      });
    }),
  );
}
